import React, { useState } from 'react';
import PropTypes from 'prop-types';
import ItemsCarousel from 'react-items-carousel';
import { FaChevronLeft, FaChevronRight } from 'react-icons/fa';
import { AddOnItem, PlanItem } from './item';
import { ProductType, RecurrenceIntervalsInDays } from '../../enums';
import {
  addExpirationDate,
  calculateApportionment,
  formatPricesByCountry,
  getGrossPrice,
  getProductByProductId,
  getSalePrice,
  hasAllUrns
} from '../../utils/products';
import cx from 'classnames';
import { FormattedMessage } from 'react-intl';


const Carousel = ({ intl, products, allProducts, onSelect, exchangeRate, userPlan, addOnSubscriptions, subscriptions, carouselOptions = {}, client, user }) => {
  const [activeItemIndex, setActiveItemIndex] = useState(1);

  const isValidProductToChange = (product) => {
    if (userPlan) {
      const mainSubscriptionProducInfo = getProductByProductId(userPlan?.productId, allProducts);
      const productDays = RecurrenceIntervalsInDays[product.interval.unit] * product.interval.amount;
      const mainSubscriptionPlanDays = RecurrenceIntervalsInDays[mainSubscriptionProducInfo.interval.unit] * mainSubscriptionProducInfo.interval.amount;

      return productDays >= mainSubscriptionPlanDays || hasAllUrns(product, user);
    }
    return true;
  }

  return (
    <div className= {
      cx('selectAddOnCarousel', {
        'selectAddOnCarousel__one-card': products.length === 1,
      })
    }>
      <ItemsCarousel
        slidesToScroll={2}
        infiniteLoop={false}
        gutter={20}
        activePosition="center"
        disableSwipe={false}
        alwaysShowChevrons={false}
        numberOfCards={products.length > 4 ? 2 : 2}
        showSlither={false}
        {...carouselOptions}
        activeItemIndex={activeItemIndex}
        requestToChangeActive={(value) => setActiveItemIndex(value)}
        rightChevron={
          <div className="chevron chevron--right">
            <div className="chevron__icon">
              <FaChevronRight size={50} />
              <small className="text-white">
                <FormattedMessage id="Caraousel.arrow.subtitle" />
              </small>
            </div>
          </div>
        }
        leftChevron={
          <div className="chevron chevron--left">
            <div className="chevron__icon">
              <FaChevronLeft size={50} />
              <small className="text-white">
                <FormattedMessage id="Caraousel.arrow.subtitle" />
              </small>
            </div>
          </div>
        }
      >
        {Array.isArray(products) && products.map((p, i) => {
          const product = addExpirationDate(p);
          const subscriptionProduct = subscriptions && subscriptions.find(sub => sub.productId === product.productID);
          const historic = subscriptionProduct?.subscriptionState?.renewalNumber;
          const isConsumedFreeTrial = !!(historic > 0);
          const applyTrial = !!(!isConsumedFreeTrial && product.trial?.unit);

          const apportionmentConfig = product && calculateApportionment(product, userPlan);
          const availableSalePriceOffer = !applyTrial && getSalePrice(product);
          const floor = getGrossPrice(availableSalePriceOffer, product);
          const userCountry = user ? user.country : userPlan?.subscriber?.countryCode;
          const price = formatPricesByCountry(floor, userCountry);

          if (product.productType === ProductType.ADD_ON) {
            return (
              <AddOnItem
                key={`${product.productID}`}
                intl={intl}
                client={client}
                user={user}
                item={product}
                applyTrial={applyTrial}
                exchangeRate={exchangeRate}
                onClick={onSelect}
                selectedPlan={userPlan}
                price={price}
                addOnSubscriptions={addOnSubscriptions}
                availableSalePriceOffer={availableSalePriceOffer}
              />
            )
          } else if (isValidProductToChange(product) && (product.productType === ProductType.PLAN || !product.productType)) {
            const isActive = userPlan?.productId.includes(product.productID);
            return (
              <PlanItem
                key={product.productID}
                intl={intl}
                price={price}
                plan={product}
                allProducts={allProducts}
                applyTrial={applyTrial}
                apportionmentConfig={apportionmentConfig}
                onClick={onSelect}
                active={isActive}
                disabled={isActive}
                availableSalePriceOffer={availableSalePriceOffer}
                client={client}
                userCountry={userCountry}
              />
            )
          }
        })}
      </ItemsCarousel>
    </div>)
};

Carousel.propTypes = {
  intl: PropTypes.object.isRequired,
  client: PropTypes.string.isRequired,
  products: PropTypes.array.isRequired,
  onSelect: PropTypes.func.isRequired,
  exchangeRate: PropTypes.number,
  selectedMembership: PropTypes.object,
  userPlan: PropTypes.object,
  user: PropTypes.object,
  addOnSubscriptions: PropTypes.array,
  subscriptions: PropTypes.array,
  subscriber: PropTypes.object,
  carouselOptions: PropTypes.object,
  allProducts: PropTypes.array
}

export default Carousel;
